<template>
	<div class="h_pics_control clearfix">
			<div class="pic_cur_wrap outdoor" v-show="bigStatus">
				<div class="paddle_nav">
					<i class="icon-leftArrow pre" style="display:none;" @click="prevImg" ref="prevImg"></i>
					<i class="icon-rightArrow next" @click="nextImg" v-show="dataObj&&dataObj.length>1" ref="nextImg"></i>
				</div>
				<img :src="imgCur.imgurl2" id="bigImg" style="width:772px; height:473px; left:0px; top:0px;" ref="bigImg">
				<div class="popup" ref="popup"><span>最后一张</span></div>
			</div>
			<div class="thumbnail">
				<div class="coat clearfix" id="coat">
					<img v-for="(img,idx) in imgData.outdoor" :src="img.imgurl2" :class="((imgIdx-1)==idx&&showType=='outdoor')?'item on':'item'" v-show="allType||showList=='outdoor'" @click="bigImgsShow($event,idx,'outdoor')">
					<img v-for="(img,idx) in imgData.indoor" :src="img.imgurl2" :class="((imgIdx-1)==idx&&showType=='indoor')?'item on':'item'" v-show="allType||showList=='indoor'" @click="bigImgsShow($event,idx,'indoor')">
					<img v-for="(img,idx) in imgData.room" :src="img.imgurl2" :class="((imgIdx-1)==idx&&showType=='room')?'item on':'item'" v-show="allType||showList=='room'" @click="bigImgsShow($event,idx,'room')">
					<img v-for="(img,idx) in imgData.meeting" :src="img.imgurl2" :class="((imgIdx-1)==idx&&showType=='meeting')?'item on':'item'" v-show="allType||showList=='meeting'" @click="bigImgsShow($event,idx,'meeting')">
					<img v-for="(img,idx) in imgData.other" :src="img.imgurl2" :class="((imgIdx-1)==idx&&showType=='other')?'item on':'item'" v-show="allType||showList=='other'" @click="bigImgsShow($event,idx,'other')">				
				</div>
			</div>
			<div class="cl_wrap">
				<div class="overview_btn all" @click="allShow">
					<div class="coat">
						<span :class="allType?'click part':'part'"></span>
						<span :class="allType?'click part':'part'"></span>
						<span :class="allType?'click part':'part'"></span>
						<span :class="allType?'click part':'part'"></span>
					</div>
				</div>
				<ul class="cl_list">
					<li :class="{'active':(showType=='outdoor'&&!allType)}" v-show="imgData.outdoor.length>0" @click="changeType('outdoor')">
						<span>外景图</span>
						<div class="count_wrap">
							<span class="posi_num" v-show="showType=='outdoor'">{{imgIdx}}</span><span class="split" v-show="showType=='outdoor'">/</span><span class="total">{{imgData.outdoor.length}}</span>
						</div>
					</li>
					<li :class="{'active':(showType=='indoor'&&!allType)}" v-show="imgData.indoor.length>0" @click="changeType('indoor')">
						<span>内景图</span>
						<div class="count_wrap">
							<span class="posi_num" v-show="showType=='indoor'">{{imgIdx}}</span><span class="split" v-show="showType=='indoor'">/</span><span class="total">{{imgData.indoor.length}}</span>
						</div>
					</li>
					<li :class="{'active':(showType=='room'&&!allType)}" v-show="imgData.room.length>0" @click="changeType('room')">
						<span>房型图</span>
						<div class="count_wrap">
							<span class="posi_num" v-show="showType=='room'">{{imgIdx}}</span><span class="split" v-show="showType=='room'">/</span><span class="total">{{imgData.room.length}}</span>
						</div>
					</li>
					<li :class="{'active':(showType=='meeting'&&!allType)}" v-show="imgData.meeting.length>0" @click="changeType('meeting')">
						<span>会议室</span>
						<div class="count_wrap">
							<span class="posi_num" v-show="showType=='meeting'">{{imgIdx}}</span><span class="split" v-show="showType=='meeting'">/</span><span class="total">{{imgData.meeting.length}}</span>
						</div>
					</li>
					<li :class="{'active':(showType=='other'&&!allType)}" v-show="imgData.other.length>0" @click="changeType('other')">
						<span>其他图</span>
						<div class="count_wrap">
							<span class="posi_num" v-show="showType=='other'">{{imgIdx}}</span><span class="split" v-show="showType=='other'">/</span><span class="total">{{imgData.other.length}}</span>
						</div>
					</li>
				</ul>
			</div>
		</div>
</template>
<script>
	export default {
		name: 'picturePreview',
		props:{
			dataObj: {
		      type: [Object,Array]
		    }
		},
		data() {
			return {
				isShowed: false,
				imgData:{
					outdoor:[],
					indoor:[],
					room:[],
					meeting:[],
					other:[],
				},				
				showType:"",
				showList:"",
				imgCur:{},
				imgIdx:1,
				prevStatus:false,
				nextStatus:false,
				dataNameList:[],
				titleName:{
					outdoor:"外景图",
					indoor:"内景图",
					room:"房型图",
					meeting:"会议室",
					other:"其他图"
				},
				allType:false,
				bigStatus:true
			}
		},
		created(){
			this.imgList();
		},
		methods: {	
			changeType(name){
				var bigImg=this.$refs[`bigImg`];
				var _nodes=document.getElementById("coat").childNodes;
				var _this=this;
				var _offset;
				this.allType=false;
				if(name==this.showList||this.allType){
					_nodes.forEach(function(v){
						if(_this.commonDom.hasClass("on",v)){
							_offset=_this.offset(v);
						}
					});
				}else{
					this.showList=name;
					_offset={
						left:308,
						top:465
					};	
				}
				
				this.animate(bigImg,{width:144,height:90,left:_offset.left,top:_offset.top},1,0.1,function(){
					bigImg.style.display="none";
					_this.bigStatus=false;
				})
			},
			allShow(){
				this.allType=true;
				var bigImg=this.$refs[`bigImg`];
				var _nodes=document.getElementById("coat").childNodes;
				var _this=this;
				var _offset;
				_nodes.forEach(function(v){
					if(_this.commonDom.hasClass("on",v)){
						_offset=_this.offset(v);
					}
				});				
				this.animate(bigImg,{width:144,height:90,left:_offset.left,top:_offset.top},1,0.1,function(){
					bigImg.style.display="none";
					_this.bigStatus=false;					
				});
			},
			bigImgsShow(event,idx,type){
				this.showList=type;
				this.showType=type;
				this.allType=false;
				this.imgIdx=idx+1;
				var _offset=this.offset(event.target);
				this.bigStatus=true;
				this.imgCur=this.imgData[this.showType][this.imgIdx-1];
				var bigImg=this.$refs[`bigImg`];
				bigImg.style.display="block";	
				bigImg.style.left=_offset.left+"px";
				bigImg.style.top=_offset.top+"px";
				var prevImg=this.$refs[`prevImg`];
				var nextImg=this.$refs[`nextImg`];
				var _idx=this.dataNameList.indexOf(this.showType);
				/*nextImg.style.display="block";
				prevImg.style.display="block";*/
				this.fadeIn(nextImg,30);
				this.fadeIn(prevImg,30);
				if((_idx+1)==this.dataNameList.length&&this.imgIdx==this.imgData[this.showType].length){
					nextImg.style.display="none";
					this.fadeOut(nextImg,30);
				}else if(_idx==0&&this.imgIdx==1){
					prevImg.style.display="none";
					this.fadeOut(prevImg,30);
				}
				this.animate(bigImg,{width:772,height:473,left:0,top:0},1,0.1,function(){
									
				});
			},
			animate(obj, json, interval, sp, fn) {
			    clearInterval(obj.timer);
			    //var k = 0;
			    //var j = 0;
			    function getStyle(obj, arr) {
			        if(obj.currentStyle){
			            return obj.currentStyle[arr];    //针对ie
			        } else {
			            return document.defaultView.getComputedStyle(obj, null)[arr]; 
			        }
			    }
			    obj.timer = setInterval(function(){
			        //j ++;
			        var flag = true;
			        for(var arr in json) {
			            var icur = 0;
			            //k++;
			            if(arr == "opacity") {
			                icur = Math.round(parseFloat(getStyle(obj, arr))*100);
			            } else {
			                icur = parseInt(getStyle(obj, arr));
			            }
			            var speed = (json[arr] - icur) * sp;
			            speed = speed > 0 ? Math.ceil(speed): Math.floor(speed);
			            if(icur != json[arr]){
			                flag = false;
			            } 
			            if(arr == "opacity"){
			                obj.style.filter = "alpha(opacity : '+(icur + speed)+' )";
			                obj.style.opacity = (icur + speed)/100;
			            }else {
			                obj.style[arr] = icur + speed + "px";
			            }
			            //console.log(j + "," + arr +":"+ flag);
			        }

			        if(flag){
			            clearInterval(obj.timer);
			            //console.log(j + ":" + flag);  
			            //console.log("k = " + k);
			            //console.log("j = " + j);
			            //console.log("DONE");
			            if(fn){
			                fn();
			            }
			        }
			    },interval);
			},
			offset(ele){
				var top = ele.offsetTop;
			    var left = ele.offsetLeft;
			  /*  while (ele.offsetParent) {
			        ele = ele.offsetParent;
			        if (window.navigator.userAgent.indexOf('MSTE 8') > -1) {
			            top += ele.offsetTop;
			            left += ele.offsetLeft;
			        } else {
			            top += ele.offsetTop + ele.clientTop;
			            left += ele.offsetLeft + ele.clientLeft;
			        }
			    }*/
			    return {
			        left: left,
			        top: top
			    }
			},	
			nextImg(){
				var popup=this.$refs[`popup`];
				var prevImg=this.$refs[`prevImg`];
				var nextImg=this.$refs[`nextImg`];
				var _idx=this.dataNameList.indexOf(this.showType);
				var _this=this;
				if((_idx+1)==this.dataNameList.length&&this.imgIdx==this.imgData[this.showType].length) return;
				if(this.imgIdx==this.imgData[this.showType].length){
					popup.childNodes[0].innerHTML=this.titleName[this.dataNameList[_idx+1]];
					this.showType=this.dataNameList[_idx+1];
					this.fadeIn(popup,10);
				 	setTimeout(function(){
				 		_this.fadeOut(popup,10);
				 	},500);
					this.imgIdx=1;
				}else{
					 this.imgIdx+=1;
					 if((_idx+1)==this.dataNameList.length&&this.imgIdx==this.imgData[this.showType].length){
					 	popup.childNodes[0].innerHTML="最后一张";
					 	this.fadeIn(popup,10);
					 	this.fadeOut(nextImg,30);
					 	setTimeout(function(){
					 		_this.fadeOut(popup,10);
					 	},500);
					 }					
				};	
				
				this.imgCur=this.imgData[this.showType][this.imgIdx-1];
				this.fadeIn(prevImg,30);
			},
			prevImg(){
				var popup=this.$refs[`popup`];
				var prevImg=this.$refs[`prevImg`];
				var nextImg=this.$refs[`nextImg`];
				var _idx=this.dataNameList.indexOf(this.showType);
				var _this=this;
				if(_idx==0&&this.imgIdx==1) return;
				if(this.imgIdx==1){
					popup.childNodes[0].innerHTML=this.titleName[this.dataNameList[_idx-1]];
					this.showType=this.dataNameList[_idx-1];
					this.fadeIn(popup,10);
				 	setTimeout(function(){
				 		_this.fadeOut(popup,10);
				 	},500);
					this.imgIdx=this.imgData[this.showType].length;
				}else{
					 this.imgIdx-=1;
					 if(_idx==0&&this.imgIdx==1){
					 	popup.childNodes[0].innerHTML="第一张";
					 	this.fadeIn(popup,10);
					 	this.fadeOut(prevImg,30);
					 	setTimeout(function(){
					 		_this.fadeOut(popup,10);
					 	},500);
					 }					
				};	
				
				this.imgCur=this.imgData[this.showType][this.imgIdx-1];
				this.fadeIn(nextImg,30);
			},
			imgList(){
				var _this=this;
				if(this.dataObj){
					this.dataObj.forEach(function(v){
						switch(v.imgType){
							case "1":
							_this.imgData.room.push(v)
							break;
							case "2":
							_this.imgData.outdoor.push(v)
							break;
							case "3":
							_this.imgData.indoor.push(v)
							break;
							case "4":
							_this.imgData.indoor.push(v)
							break;
							case "6":
							_this.imgData.meeting.push(v)
							break;
							case "7":
							_this.imgData.meeting.push(v)
							break;
							default:
							_this.imgData.other.push(v)
						}
					});
				};
				if(this.dataObj.length>1){
					this.nextStatus=true;
				}

				if(this.imgData.outdoor.length>0) this.dataNameList.push("outdoor");
				if(this.imgData.indoor.length>0) this.dataNameList.push("indoor");
				if(this.imgData.room.length>0) this.dataNameList.push("room");
				if(this.imgData.meeting.length>0) this.dataNameList.push("meeting");
				if(this.imgData.other.length>0) this.dataNameList.push("other");

				if(this.imgData.outdoor.length>0){
					this.imgCur=this.imgData.outdoor[0];
					this.showType="outdoor";
				}else if(this.imgData.indoor.length>0){
					this.imgCur=this.imgData.indoor[0];
					this.showType="indoor";
				}else if(this.imgData.room.length>0){
					this.imgCur=this.imgData.room[0];
					this.showType="room";
				}else if(this.imgData.meeting.length>0){
					this.imgCur=this.imgData.meeting[0];
					this.showType="meeting";
				}else if(this.imgData.other.length>0){
					this.imgCur=this.imgData.other[0];
					this.showType="other";
				}
				this.showList=this.showType;
				this.imgIdx=1;
			},
			setOpacity(ele, opacity) {  
			    if (document.all) {  
			        ///兼容ie  
			        ele.style.filter = "alpha(opacity=" + opacity + ")";  
			    }  
			    else {  
			        ///兼容FF和GG  
			        ele.style.opacity = opacity / 100;  
			    }  
			},
			fadeIn(ele,speed) {  
				var _this=this;
			    if (ele&&ele.style.display!="block") {  	    	
			        var v = 0;
			        var timer = null;   
			        ele.style.display="block";
			        this.setOpacity(ele, 0);
			        timer = setInterval(function() {  
			            if (v < 100) {  
			                v += 10;  
			                _this.setOpacity(ele, v);  
			            }else{  
			                clearInterval(timer);  
			            }  
			        }, speed);  
			    }  
			},
			fadeOut(ele,speed) {  
				var _this=this;
			    if(ele&&ele.style.display!="none") {  
			        var v = 100;
			        var timer = null;   		      
			        this.setOpacity(ele, 100);
			        timer = setInterval(function() {  
			            if (v > 0) {  
			                v -= 10;  
			                _this.setOpacity(ele, v);  
			            }else{  
			                clearInterval(timer); 
			                ele.style.display="none"; 
			            }  
			        }, speed);
			    }  
			}  
		},
		mounted() {
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/picturePreview/picturePreview.vue